import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

export const AdFixusScriptTags = ({ marketing }) => {
  return (
    <Helmet>
      {marketing?.adFixus &&
        (function () {
          const fullUrl = window.location.href;
          const url = new URL(fullUrl);
          const siteBaseUrl = `${url.protocol}//${url.hostname}`;

          const preloadScriptLink = document.createElement('link');
          preloadScriptLink.rel = 'preload';
          preloadScriptLink.href = `${siteBaseUrl}/afx_prid/2024.7.25.1/auth/ps/p20247251.js?lcsid=4F408152-EA4D-4FDB-B34B-617BEE36F5C3`;
          preloadScriptLink.as = 'script';

          const mainScriptLink = document.createElement('script');
          mainScriptLink.importance = 'high';
          mainScriptLink.src = `${siteBaseUrl}/afx_prid/2024.7.25.1/auth/ps/p20247251.js?lcsid=4F408152-EA4D-4FDB-B34B-617BEE36F5C3`;

          // Add link tag before the afx start script tag
          const targetElement = document.getElementById('afx_start');
          document.head.insertBefore(preloadScriptLink, targetElement);

          // insert script tag after the afx start script tag
          document.head.insertBefore(mainScriptLink, targetElement.nextSibling);
        })()}
    </Helmet>
  );
};

AdFixusScriptTags.propTypes = {
  marketing: PropTypes.shape({
    adFixus: PropTypes.bool
  })
};
